import { createI18n } from "vue-i18n";
import { EN } from "./en";
import { IT } from "./it";
import { DE } from "./de";
import { ES } from "./es";
import { FR } from "./fr";
import dayjs from "dayjs";
import config from "@/utils/const/config";
import LangStorage from "@/utils/methods/lang_storage";
import { Locale } from "@/utils/const/env";
/* DAYSJS LOCALE */
require("dayjs/locale/it");
require("dayjs/locale/es");
require("dayjs/locale/de");
require("dayjs/locale/fr");


export const defaultLanguage = (): Locale => {
  let browser_lang = (navigator.language.split("-")[0])?.toLowerCase();
  let browser_lang_exist = config.available_locales.includes(browser_lang);
  return LangStorage.get() ?? (browser_lang_exist ? (browser_lang as Locale) : process.env.VUE_APP_LANG ?? config.available_locales[0] ?? "en");
}

export const i18n = createI18n({
  locale: defaultLanguage(),
  availableLocales: config.available_locales,
  messages: {
    en: EN,
    it: IT,
    de: DE,
    fr: FR,
    es: ES,
  },
  warnHtmlInMessage: "off",
});

export const setDayjsLocale = () => {
  dayjs.locale(defaultLanguage());
};

